import React, { useEffect, useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import {
  getSharetribeCooldownMs,
  subscribeSharetribeCooldown,
} from '../../util/sharetribeSafeQuery';
import { Heading, IconSpinner, PrimaryButton } from '../../components';

import css from './TooManyRequestsPage.module.css';

/**
 * In-place busy state when Sharetribe rate-limits a page. Auto-retries
 * after Retry-After / cooldown. Must never look like a missing route.
 *
 * @returns {JSX.Element}
 */
const TooManyRequestsPage = () => {
  const [waitMs, setWaitMs] = useState(() => getSharetribeCooldownMs());

  useEffect(() => subscribeSharetribeCooldown(setWaitMs), []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const delay = Math.max(waitMs, 8000);
    const timer = window.setTimeout(() => {
      window.location.reload();
    }, delay);
    return () => window.clearTimeout(timer);
  }, [waitMs]);

  const onRetry = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    <div className={css.root} data-page="too-many-requests" data-busy-retrying="true" role="status">
      <div className={css.content}>
        <Heading as="h1" rootClassName={css.heading}>
          <FormattedMessage
            id="TooManyRequestsPage.heading"
            defaultMessage="We’re busy. Retrying…"
          />
        </Heading>
        <p className={css.description}>
          <FormattedMessage
            id="TooManyRequestsPage.description"
            defaultMessage="This page is still here. We are waiting a moment and trying again. This is not a missing page."
          />
        </p>
        <IconSpinner className={css.spinner} />
        <PrimaryButton type="button" onClick={onRetry} className={css.retry}>
          <FormattedMessage id="TooManyRequestsPage.retry" defaultMessage="Retry now" />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default TooManyRequestsPage;
